import { Component, signal } from '@angular/core';

@Component({
  selector: 'app-menu-flotante',
  standalone: false,
  templateUrl: './menu-flotante.component.html',
  styleUrl: './menu-flotante.component.scss',
})
export class MenuFlotanteComponent {
  isOpen = signal(false);

  toggle() {
    this.isOpen.update(v => !v);
    // console.log(this.isOpen());
  }
}
